module.exports = __webpack_public_path__ + "img/customer-portal.4680a663.png";